import { BUNDLE_ITEMOFFERING_GET_SUCCESS } from '../actionTypes/BundleItemOfferingActionTypes';

function bundleItemOfferingReducer(state = {}, action) {
    switch (action.type) {
        case BUNDLE_ITEMOFFERING_GET_SUCCESS: {
            // return Object.assign({}, state, action.itemOffering);
            return {
                ...state,
                [action.payload.ppId]: action.payload.itemOffering,
            };
        }
        default: {
            return state;
        }
    }
}

bundleItemOfferingReducer.reducerName = 'bundleItemOffering';
export default bundleItemOfferingReducer;
